export default {
    overlays: {
        scrollbarWidth: 0,
        openOverlays: [],
        savedScrollPosition: 0,
    },
};
